import {ActionLinkTypes} from '@daedalus/core/src/offer/types/actionLink'
import {LinkType} from '@daedalus/core/src/booking/types/Link'

export const getBookingFinalizationLink = (links: LinkType[]) => {
  return links.find(link => link.type === ActionLinkTypes.BOOKING_FINALIZATION)
}
